let times = function(timess,timestamp){
    var date = new Date((timess - timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
    var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + " " + h + m + s;
}
let times2 = function(timess,timestamp){
    var date = new Date((timess - timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    var h = date.getHours() + ':';
    var m = date.getMinutes() + ':';
    var s = date.getSeconds();
    return Y + M + D;
}
let mdName = function(str){
  if(!str) return;
  if(str.length >= 7){
      return str.substr(0,3)+'****'+str.substr(7,str.split('').length)
  }else{
      return str;
  }
}
let toFixed4 = function(val){
  val = Number(val);
  return val.toFixed(4);
}
let toFixed2 = function(val){
  val = Number(val);
  return val.toFixed(2);
}
export {times,times2,mdName,toFixed4,toFixed2}



// WEBPACK FOOTER //
// ./src/utils/filters.js